import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/store";
import { shopApi } from "@/lib/api";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { LogoMark, LogoWordmark } from "@/components/Logo";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await signup(form);
      if (ref) {
        try {
          const r = await shopApi.applyReferral(ref);
          toast.success(`Welcome! Coupon ${r.coupon_code} — 10% off your first order`);
        } catch { /* ignore */ }
      } else {
        toast.success("Welcome to NovalynxTech");
      }
      nav("/");
    } catch (err) { toast.error(err.response?.data?.detail || "Signup failed"); }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8"><LogoMark size={32} /><LogoWordmark className="text-xl" /></div>
        <h1 className="font-display text-3xl font-bold mb-6">Create your account</h1>
        {ref && (
          <div className="mb-4 rounded-xl bg-primary/10 border border-primary/30 p-3 flex items-center gap-2 text-sm" data-testid="referral-banner">
            <Gift className="h-4 w-4 text-primary" />
            <span>You were invited with code <strong className="text-primary">{ref}</strong> — 10% off unlocks after signup.</span>
          </div>
        )}
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="signup-name" /></div>
          <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="signup-email" /></div>
          <div><Label>Password</Label><Input type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="signup-password" /></div>
          <Button type="submit" className="btn-primary w-full h-11" disabled={loading} data-testid="signup-submit">{loading ? "Creating…" : "Create account"}</Button>
        </form>
        <p className="text-center text-sm text-muted-foreground mt-6">Already have an account? <Link to="/login" className="text-primary">Sign in</Link></p>
      </div>
    </div>
  );
}
